import React from "react";
import { Card, Typography } from "antd";
import "./profileOverview.css";

const ProfileInfoCard = ({ title, subtitle, children, className }) => {
  const showHead = Boolean(title || subtitle);

  return (
    <Card className={`profile-overview-info-card ${className || ""}`} bordered>
      {showHead && (
        <div className="profile-overview-info-card-head">
          {title && (
            <Typography.Title level={5} className="profile-overview-info-card-title">
              {title}
            </Typography.Title>
          )}
          {subtitle && (
            <Typography.Text type="secondary" className="profile-overview-info-card-subtitle">
              {subtitle}
            </Typography.Text>
          )}
        </div>
      )}
      <div className="profile-overview-info-card-body">{children}</div>
    </Card>
  );
};

export default ProfileInfoCard;
